import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import AuthorBlock from '../../components/User/AuthorBlock';
import paths from '../../paths';

export default class ForumNewsItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      forumCategoryTitle: PropTypes.string.isRequired,
      forumCategoryAlias: PropTypes.string.isRequired,
      forumTopicTitle: PropTypes.string.isRequired,
      forumTopicAlias: PropTypes.string.isRequired,
      userId: PropTypes.string.isRequired,
      createDate: PropTypes.string.isRequired,
      user: PropTypes.object
    }).isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      topicTitleClamped: false
    };
  }

  handleReflow = (state) => {
    const { clamped, text } = state;
    // установить state только 1 раз, если произошло обрезание
    if (clamped !== true || this.state.topicTitleClamped === true) return;
    this.setState({
      topicTitleClamped: true
    });
  };

  render() {
    const {
      forumCategoryTitle,
      forumCategoryAlias,
      forumTopicTitle,
      forumTopicAlias,
      userId,
      createDate,
      user
    } = this.props.item;
    const { topicTitleClamped } = this.state;

    return (
      <div className="latest-entries-item">
        <Link
          to={`${paths.advocates.forumCategories}/${forumCategoryAlias}`}
          className="latest-entries-title"
        >
          <i className="icon icon-chat" />
          {forumCategoryTitle}
        </Link>

        <div className="latest-entries-main">
          <Link to={`${paths.advocates.forumTopic}/${forumTopicAlias}`}>
            <LinesEllipsis
              text={forumTopicTitle}
              maxLine="2"
              ellipsis="..."
              trimRight
              basedOn="letters"
              onReflow={this.handleReflow}
            />
          </Link>
        </div>

        <div className="latest-entries-footer">
          <AuthorBlock user={user} dateFormat="short" createDate={createDate} className="-m" />
        </div>
      </div>
    );
  }
}
